module.exports = __webpack_public_path__ + "static/media/boton4.4aeb49a4.svg";